export default {
  options(h, conf, key) {
    const list = []
    const opts = conf.__slot__.options || []
    const label = (conf.__config__ && conf.__config__.label) || ''
    const isTf =
      opts.length === 2 &&
      opts.some((o) => o.value === '正确' || o.label === '正确') &&
      opts.some((o) => o.value === '错误' || o.label === '错误')
    const isSingleChoice = !isTf && label !== '判断题'

    const getText = (item) => {
      if (!isSingleChoice) return item.label || item.value
      return item.label ? `${item.value}. ${item.label}` : `${item.value}`
    }

    opts.forEach(item => {
      const text = getText(item)
      if (conf.__config__.optionType === "button") {
        list.push(
          <el-radio-button label={item.value}>{text}</el-radio-button>
        )
      } else {
        list.push(
          <el-radio label={item.value} border={conf.border}>
            {text}
          </el-radio>
        )
      }
    })
    return list
  }
}
